import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDesignElementBi3 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path fill="#00A7CA" d="M0 0h24v24H0z" />
        <g fill="#fff" clipPath="url(#a)">
            <path d="m3 3 6.3 8.95-6.3 9h5.1L14.4 12 8.1 3z" />
            <path d="m9.65 3 6.3 8.95-6.3 9h5.1l6.3-8.95-6.3-9z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M3 3h18.5v18H3z" />
            </clipPath>
        </defs>
    </svg>
);
export default SvgDesignElementBi3;
